/** Bare `www.` hosts get an https scheme; anything else is returned as-is. */
export const normalizeLinkUrl = (url) =>
  /^www\./i.test(url) ? `https://${url}` : url;

/**
 * Absolute, shareable form of a link: relative in-app paths are resolved
 * against the current origin so the copied URL works outside the app.
 */
export const toAbsoluteUrl = (url) =>
  new URL(normalizeLinkUrl(url), window.location.origin).href;
